import request from '@/utils/request'
import axios from 'axios'
let preBase = 'mixApi'

/**
 * 描述 获取微信jsSDK的config签名
 * @date 2020-04-16
 * @returns {any}
 */
export const getJsApiSignApi = (key = 'ds', signUrl = undefined) => {
  const map = {
    ds: '/mixApi/complaint/getSign', // 电商
    sk: '/mixApi/complaint/getSkSign', // 数科
    wm: '/mixApi/wechatMultiAuth/getSign', // 商超营销馆
  }
  let url = map[key] || '/mixApi/complaint/getSign'
  // let url = '/complaint/getSign' // T1005475莆田邮储话费立减金小洲本地测试

  return request({
    url: url,
    method: 'post',
    headers: {},
    data: {
      signUrl: signUrl || encodeURIComponent(location.href.split('#')[0])
    },
    hideLoading: true,
  })
}

// 获取小程序短链地址 臻券馆
export const generateLink = (data) => {
  return request({
    url: `https://mapacode.quancangyun.cn/mixApi/xibGoldenCardActivity/generateLink?link=${data.link}`,
    method: 'get',
    custom: true,
    data,
  })
}

// 获取小程序短链地址 X尊享
export const generateLink2 = (data) => {
  return request({
    url: `https://mapacode.quancangyun.cn/mixApi/xibGoldenCardActivity/generateLink2?link=${data.link}`,
    method: 'get',
    custom: true,
    data,
  })
}


// 图片上传接口
export const reqUploadSign = (data) => {
  return request({
    url: `pic/saas-core-public/public_project/inside_login`,
    method: 'POST',
    data: data
  })
}

// 自定义上传文件
export function reqUploadRequest(host, data) {
  return axios.post(`${host}`, data)
}

